import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Globals } from 'app/_models/globals';

import { CotacaoSelecionada } from '../../_models/cotacaoSelecionada';
import { UserService } from 'app/_services/user.service';

declare const isEmpty: any;

@Component({
    selector: 'app-cabecalho-respostas', templateUrl: 'cabecalho-respostas.component.html', styleUrls: ['cabecalho-respostas.component.scss'],
    standalone: false
})
export class BuyerComprarCabecalhoRespostasComponent implements OnInit {
    @ViewChild('templatePecasFaltantes') templatePecasFaltantes: TemplateRef<any>;

    @Input() get respostaTipoAlerta() {
        return this._respostaTipoAlerta;
    }

    set respostaTipoAlerta(value) {
        this._respostaTipoAlerta = value;

        this.obterDanger(value);
    }

    get searchType(): string {
        return this._searchFase;
    }

    set searchType(value: string) {
        this._searchFase = value;
        this.onFilter.emit(this._searchFase);
    }

    @Input() cotacaoSelecionada: CotacaoSelecionada;
    @Input() orderType: any;
    @Output() onSort = new EventEmitter();
    @Output() onFilter = new EventEmitter();

    _respostaTipoAlerta;
    _searchFase;
    modalPecasFaltantes: BsModalRef;
    translateFaltamPecas: string;
    translateFaltamPecasText: string;

    constructor(public userService: UserService, private modalService: BsModalService, public globals: Globals) {
        this.searchType = '1';
        this.translateFaltamPecasText = this.globals.translate('buyer.cotacao.area-respostas.alerta.vermelho.parte2');
    }

    ngOnInit() { }

    executeSort(tipo_ordenacao): void {
        this.onSort.emit(tipo_ordenacao);
    }

    modal_abrir() {
        this.modalPecasFaltantes = this.modalService.show(this.templatePecasFaltantes, { class: 'gray modal-lg' });
    }

    modal_fechar() {
        this.modalPecasFaltantes.hide();
    }

    obterDanger(respostaTipoAlerta) {
        var cotacao = this.cotacaoSelecionada;

        if (isEmpty(cotacao))
            return '';

        var totalPecas = isEmpty(cotacao.itens) ? cotacao.total_pecas : cotacao.itens.length;
        var pecasEncontradas = totalPecas - respostaTipoAlerta.nao_encontradas.length;

        this.translateFaltamPecas = this.translateFaltamPecasText.replace('{0}', pecasEncontradas.toString()).replace('{1}', totalPecas.toString());
    };
}
